import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16 8.25C16 7.83579 15.7172 7.5 15.3684 7.5H8.63158L8.54588 7.50685C8.2376 7.55651 8 7.8703 8 8.25C8 8.66421 8.28277 9 8.63158 9H15.3684L15.4541 8.99315C15.7624 8.94349 16 8.6297 16 8.25Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.3684 11.2C15.7172 11.2 16 11.5358 16 11.95C16 12.3297 15.7624 12.6435 15.4541 12.6932L15.3684 12.7H8.63158C8.28277 12.7 8 12.3642 8 11.95C8 11.5703 8.2376 11.2565 8.54588 11.2068L8.63158 11.2H15.3684Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 15.65C16 15.2358 15.7172 14.9 15.3684 14.9H8.63158L8.54588 14.9068C8.2376 14.9565 8 15.2703 8 15.65C8 16.0642 8.28277 16.4 8.63158 16.4H15.3684L15.4541 16.3932C15.7624 16.3435 16 16.0297 16 15.65Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 2.5C19.5523 2.5 20 2.94772 20 3.5V20.5C20 21.0523 19.5523 21.5 19 21.5H5C4.44772 21.5 4 21.0523 4 20.5V6.87812C4 6.57956 4.11129 6.29173 4.31214 6.07084L7.26131 2.82727C7.45083 2.61883 7.71948 2.5 8.0012 2.5H19ZM18.5 4H8.222L5.5 6.992V20H18.5V4Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }